import { RightSidebarXLLayout } from '@wwe-portal/ui/layout/app';
import { ProfileSectionSkeleton } from '@wwe-portal/ui/layout/app/right-sidebar';

import { Skeleton } from '@wwe-portal/ui/components/skeleton';

export const RightSidebarXLContentSkeleton = () => (
  <RightSidebarXLLayout
    loginButton={null}
    calendarButton={null}
    header={<Skeleton className="h-10 w-[240px]" />}
    emailSubcription={null}
    userProfile={<ProfileSectionSkeleton />}
  />
);
